import type { Photo } from '@/lib/types';
import hero from '@/assets/hero-workshop.jpg';
import examPractical from '@/assets/exam-practical.jpg';
import affiliation from '@/assets/affiliation-institute.jpg';
import contact from '@/assets/contact-mumbai.jpg';
import goa from '@/assets/event-goa-seminar-01.jpg';
import logoSrc from '@/assets/ites-logo.png';
import electronics from '@/assets/course-electronics.jpg';
import electrical from '@/assets/course-electrical.jpg';
import mechanical from '@/assets/course-mechanical.jpg';
import civil from '@/assets/course-civil-interior.jpg';
import computer from '@/assets/course-computer.jpg';
import professional from '@/assets/course-professional.jpg';
import automobile from '@/assets/course-automobile.jpg';
import teacher from '@/assets/course-teacher-training.jpg';
import acRef from '@/assets/course-ac-refrigeration.jpg';

// width/height are the pixel size of the file on disk (after the lossless crop
// of the black padding). They reserve space before the image loads.
const course = (src: string): Photo => ({ src, width: 1445, height: 1083, alt: '' });

export const photos = {
  hero: {
    src: hero, width: 1669, height: 938,
    alt: "A student's hands testing a circuit board with a multimeter at a workshop bench",
  },
  examPractical: {
    src: examPractical, width: 1533, height: 1021,
    alt: 'A practical examination bench with hand tools and an answer booklet',
  },
  affiliation: {
    src: affiliation, width: 1533, height: 1021,
    alt: 'A vocational institute workshop with workbenches',
  },
  contact: {
    src: contact, width: 2045, height: 765,
    alt: 'A quiet Mumbai street beside a suburban railway station in the morning',
  },
  goaEvent: {
    src: goa, width: 2592, height: 1944,
    alt: 'Members and guests seated in a classroom at an ITES gathering',
  },
  goaAbout: {
    src: goa, width: 2592, height: 1944,
    alt: 'Members and guests at the ITES seminar in Goa',
  },
} satisfies Record<string, Photo>;

export const logo = {
  src: logoSrc, width: 1002, height: 101,
  alt: 'Indian Technical Education Society – Mumbai, home',
};

export const coursePhotos = {
  electronics: course(electronics),
  electrical: course(electrical),
  mechanical: course(mechanical),
  'civil-interior': course(civil),
  computer: course(computer),
  professional: course(professional),
  automobile: course(automobile),
  'teacher-training': course(teacher),
  'ac-refrigeration': course(acRef),
};
